import React, { useState, useEffect } from "react";
import { getAllTables, updateTableStatus } from "../../Services/TablesApi";
import { useOrganisations } from "../../Auth/useOrganisations";

const TablesDisplay = ({
  tables,
  onTableSelect,
  selectedTable,
  onOccupiedTableClick, // Add this prop
}) => {
  // Effect to handle when selectedTable becomes null (e.g., when user clears selection)
  useEffect(() => {
    if (!selectedTable && tables && tables.length > 0) {
      const defaultTable = tables.find((table) => table.default === true);
      if (defaultTable && onTableSelect) {
        onTableSelect(defaultTable);
      }
    }
  }, [selectedTable, tables, onTableSelect]);

  const getStatusColor = (status) => {
    switch (status) {
      case "available":
        return "#4CAF50";
      case "occupied":
        return "#f44336";
      case "reserved":
        return "#ff9800";
      case "cleaning":
        return "#2196F3";
      default:
        return "#757575";
    }
  };

  const handleTableClick = (table) => {
    // If table is occupied and we have the onOccupiedTableClick function,
    // check if it has session data to load
    if (table.status === "occupied" && onOccupiedTableClick) {
      // Prepare the table data to pass to parent

      onOccupiedTableClick(table);
    } else {
      // For available tables or when no session data exists
      onTableSelect && onTableSelect(table);
    }
  };

  return (
    <div className="content-wrapper pt-4" style={{ margin: 0 }}>
      <div
        className="container-full"
      >
        <div className="tables-display">
          <div className="tables-grid">
            {tables.map(
              (table) =>
                !table.default && (
                  <div
                    key={table._id}
                    className={`table-item ${
                      table.status === "reserved"
                        ? "reserved"
                        : table.status === "occupied"
                        ? "occupied"
                        : "available"
                    }`}
                    onClick={() => handleTableClick(table)}
                  >
                    <div className="table-number">
                      <img
                        src={
                          table.status === "available"
                            ? "images/available.png"
                            : "images/full.png"
                        }
                        style={{ maxWidth: "30%" }}
                        alt="Available"
                      />
                    </div>
                    <div className="table-number">
                      Table {table.table_number}
                    </div>
                    {table.status === "available" && (
                      <div
                        className="table-status"
                        style={{
                          backgroundColor: getStatusColor(table.status),
                        }}
                      >
                        Réserver
                      </div>
                    )}
                    {/* Show occupied indicator */}
                    {/* {table.status === "occupied" && (
                      <div
                        className="table-status"
                        style={{
                          backgroundColor: getStatusColor(table.status),
                        }}
                      >
                        Occupée
                      </div>
                    )} */}
                  </div>
                )
            )}
          </div>
          {tables.length === 0 && (
            <div className="no-tables">
              <div className="no-tables-icon">🍽️</div>
              <p>Aucune table disponible</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TablesDisplay;
